
const isDEV = false
const JiraAPiUrl = {
  jira: "api/jira",
  milestone: "api/jira/milestone"
}

const ProjectApiUrl = {
  project: "api/project"
}

const RouteApiUrl = {
  route: "api/route"
}

export const BASE_API = isDEV ? "http://localhost:3888" : 'http://www.everythingnest.cn'

export {
  JiraAPiUrl,
  ProjectApiUrl,
  RouteApiUrl
}